import React, { useContext, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import InputText from '../../DevComponents/InputText'
import { ContextoGlobal, ContextoGlobalInterface } from '../../GlobalStates/ContextoGlobal'
import Condicional from '../../Layout/Condicional'
import Button from '@mui/material/Button'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import DataTable, { DataTableCabecalhoInterface } from '../../DevComponents/DataTable'
import { useNavigate } from 'react-router-dom'
import { VeiculoInterface } from '../../ImportBackend/Interfaces/VeiculoInterfaces'
import ClsCrud, { StatusForm } from '../../Utils/ClsCrud'
import ClsValidacao from '../../Utils/ClsValidacao'
import TextArea from '../../DevComponents/TextArea'
import ExibirJSONDev from '../../DevComponents/ExibirJSONDev'

interface PesquisaInterface {
  descricao: string
}

interface PropsInterface {
  onClose?: () => void
}

export default function Veiculos({ onClose }: PropsInterface) {

  const [statusForm, setStatusForm] = useState<StatusForm>(StatusForm.Pesquisando)

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'placa',
      cabecalho: 'Placa',
      alinhamento: 'left'
    },
    {
      campo: 'descricao',
      cabecalho: 'Descrição',
      alinhamento: 'left'
    }
  ]

  const ResetDados: VeiculoInterface = {
    idVeiculo: 0,
    descricao: '',
    placa: '',
    jsonCadastroTrucks: '',
    jsonCadastroAutoTrac: '',
  }

  const TituloForm = {
    [StatusForm.Incluindo]: 'Inclusão de Novo Veículo',
    [StatusForm.Excluindo]: 'Exclusão de Veículo',
    [StatusForm.Pesquisando]: 'Cadastro de Veículos',
    [StatusForm.Editando]: 'Alteração de Dados do Veículo',
    [StatusForm.Exibindo]: 'Dados do Veículo'
  }

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const [dados, setDados] = useState<VeiculoInterface>(ResetDados)
  const [erros, setErros] = useState({})
  const [pesquisa, setPesquisa] = useState<PesquisaInterface>({ descricao: '' })
  const [rsPesquisa, setRsPesquisa] = useState<Array<VeiculoInterface>>([])

  const navigate = useNavigate()

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.naoVazio('descricao', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('placa', dados, erros, retorno)

    setErros(erros)

    return retorno

  }

  const clsCrud: ClsCrud<VeiculoInterface> = new ClsCrud(
    navigate,
    ResetDados,
    setStatusForm,
    setDados,
    setErros,
    mensagemState,
    setMensagemState,
    setRsPesquisa,
    contexto,
    validarDados,
    {
      confirmarMutation: 'updateVeiculo',
      excluirMutation: 'delVeiculo',
      campoId: 'idVeiculo',
      camposPesquisa: '{idVeiculo placa descricao}',
      pesquisaQuery: 'getVeiculos',
      pesquisaPorId: 'getVeiculoPorId',
      camposPesquisaPorId: '{idVeiculo placa descricao jsonCadastroTrucks jsonCadastroAutoTrac}'
    },
    {
      confirmando: 'Atualizando Veículo',
      erroCadastro: 'Erro ao Cadastrar Veículo',
      erroExclusao: 'Erro ao Excluir Veículo',
      erroPesquisa: 'Erro ao Pesquisar Veículo',
      pesquisando: 'Pesquisando Veículos...',
      sucessoCadastro: 'Veículo Cadastrado com sucesso!',
      atualizacaoSucesso: 'Veículo Atualizado com sucesso!',
      tituloConfirmado: 'Confirmado!',
      sucessoExclusao: 'Veículo Excluído com sucesso...',
      tituloConfirmacaoExclusao: 'Confirma?',
      tituloErroCadastro: 'Erro!',
      tituloErroExclusao: 'Erro!',
      tituloErroPesquisa: 'Erro!',
      excluindo: 'Excluindo Veículo...'
    }
  )

  const onKeyPesquisa = () => {
    clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)
  }

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Cadastro de Veículos
                <Typography variant="body2" gutterBottom>
                  {TituloForm[statusForm]}
                </Typography>
              </Typography>

              <IconButton onClick={() => onClose ? onClose() : statusForm === StatusForm.Pesquisando ? clsCrud.btFechar() : clsCrud.btCancelar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>

              <Grid item xs={12} sm={10} sx={{ mb: 3 }}>
                <InputText
                  dados={pesquisa}
                  field='descricao'
                  label='Pesquisar'
                  setState={setPesquisa}
                  iconeEnd="search"
                  onClickIconeEnd={() => clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)}
                  mapKeyPress={[{ key: 'Enter', onKey: onKeyPesquisa }]}
                />
              </Grid>

              <Grid item xs={12} sm={2} alignSelf='center' sx={{ mt: { xs: 0, sm: 2 }, textAlign: { xs: 'right', sm: 'center' } }}>
                <Button variant='contained' onClick={() => clsCrud.btIncluir()}>Incluir</Button>
              </Grid>

            </Condicional>

            <Condicional condicao={statusForm !== StatusForm.Pesquisando}>

              <Grid item xs={12} sm={3}>
                <InputText
                  dados={dados}
                  field='placa'
                  label='Placa'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={7}
                  tipo='uppercase'
                />
              </Grid>

              <Grid item xs={12} sm={9} sx={{ pl: { sm: 1 } }}>
                <InputText
                  dados={dados}
                  field='descricao'
                  label='Descrição'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={100}
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 1 }}>
                <TextArea
                  dados={dados}
                  field='jsonCadastroTrucks'
                  label='JSON Cadastro Trucks'
                  setState={setDados}
                  disabled={true}
                  height='120px'
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 1 }}>
                <TextArea
                  dados={dados}
                  field='jsonCadastroAutoTrac'
                  label='JSON Cadastro Autotrac'
                  setState={setDados}
                  disabled={true}
                  height='120px'
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>

                <Condicional condicao={statusForm === StatusForm.Excluindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmarExclusao(dados, mensagemState, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Condicional condicao={statusForm !== StatusForm.Excluindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmar(dados, mensagemState, statusForm, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => clsCrud.btCancelar()}>Cancelar</Button>

              </Grid>

            </Condicional>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>
              <Grid item xs={12} sx={{ mt: 3 }}>
                <DataTable dados={rsPesquisa} cabecalho={Cabecalho} acoes={[
                  { icone: 'delete', toolTip: 'Excluir', onAcionador: clsCrud.btExcluir },
                  { icone: 'create', toolTip: 'Alterar', onAcionador: clsCrud.btEditar }
                ]} />
              </Grid>
            </Condicional>

            <ExibirJSONDev oque={['Dados', dados, 'Erros', erros]} />

          </Grid>
        </Paper>

      </Container>
    </>
  )
}
